import {  Switch, Route,BrowserRouter } from "react-router-dom";
import './App.css';
import LandingPage from './components/LandingPage';
import VideoPage from "./components/VideoPage";

export const config = {
  endpoint:'https://0ec0b8e5-d402-4081-b8a1-f28f5f8c8ce5.mock.pstmn.io'
}
function App() {
  return (

    <BrowserRouter>
    <div>
      <Switch>
        <Route exact path='/'>
          <LandingPage/>
        </Route>
        <Route path="/video/:id">
          <VideoPage key={window.location.href}/>
        </Route>
      </Switch>
    </div>
    </BrowserRouter>
      
  
  );
}

export default App;
